import store from '@/store';
import {Action, getModule, Module, MutationAction, VuexModule} from 'vuex-module-decorators';
import { IServiceCosmetologists, IServiceCosmetologistsListItem } from '@/entity/serviceCosmetologists/serviceCosmetologists.types';
import {PaginationRequestType} from "@/entity/common/pagination.types";
import { ServiceCosmetologistRequestType } from '@/form/serviceCosmetologist/serviceCosmetologist.types';
import {ResponseDataType} from "@/form/form.types";
import { prepareFormData } from '@/store/utils/formDataHelper'

@Module({
    namespaced: true,
    name: 'serviceCosmetologists',
    store,
    dynamic: true
})

class ServiceCosmetologistsModule extends VuexModule{
    serviceCosmetologist: IServiceCosmetologists | null = null;
    serviceCosmetologists:  IServiceCosmetologistsListItem | null = null;
    serviceCosmetologistLoaded   = false;
    serviceCosmetologistsLoaded  = false;

    @MutationAction
    async fetchAll(data?: PaginationRequestType): Promise<{ serviceCosmetologist: IServiceCosmetologists;   serviceCosmetologistLoaded: boolean }> {
        let serviceCosmetologistLoaded = false;
        const serviceCosmetologist = await store.$repository.serviceCosmetologists.fetchAll(prepareFormData(data));
        if(serviceCosmetologist){
            serviceCosmetologistLoaded = true;
        }
        return { serviceCosmetologist, serviceCosmetologistLoaded}
    }

    @MutationAction
    async fetchData(data: PaginationRequestType): Promise<{ serviceCosmetologists: IServiceCosmetologistsListItem; serviceCosmetologistsLoaded: boolean }> {
        let serviceCosmetologistsLoaded = false;
        const serviceCosmetologists = await store.$repository.serviceCosmetologists.fetchData(data);
        if (serviceCosmetologists) {
            serviceCosmetologistsLoaded = true;
        }
        return { serviceCosmetologists, serviceCosmetologistsLoaded};
    }

    @Action({rawError: true})
    async create(data: ServiceCosmetologistRequestType): Promise<ResponseDataType> {
        const resp = await store.$repository.serviceCosmetologists.create(data);
        return resp;
    }
    @Action({rawError: true})
    async update(data: ServiceCosmetologistRequestType): Promise<ResponseDataType> {
        const resp = await store.$repository.serviceCosmetologists.update(data);
        return resp;
    }
    @Action({rawError: true})
    async delete(data: {cosmetologist_id: number, service_id: number}): Promise<ResponseDataType> {
        const resp = await store.$repository.serviceCosmetologists.delete(data);
        return resp;
    }
}

export const ServiceCosmetologistsStore = getModule(ServiceCosmetologistsModule);